//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import global_ from "../global";
import wx from 'weixin-js-sdk'

export default {
  name: "addsaleslog",
  props: {
    date: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      textnum: 2,
      info: {
        customer_visited: [],
        project_added: [],
        project_updated: [],
        appendix: [],
        photos: [],
        solutions: [],
        myscore: ''
      },
      next: '',
      resource: '',
      other: '',
      visiable: [],
      visiableUserList: [],
      visiableUser: [],
      isClear: '',
      isVisitedCustomer: false,
      isSolutionCustomer: false,
      customerList: [],
      dateTime: this.date,
      isEditChange: this.isEdit,
      imgList: []
    }
  },
  methods: {
    addVisited() {
      this.info.customer_visited.push({
        customer: '',
        name: '',
        title: '',
        mobile: '',
        accompany: '',
        communicate: '',
        content: '',
        plan: '',
        prop: '',
        photos: []
      })
      this.imgList.push([]);
    },
    addSolution() {
      this.info.solutions.push({customer: '', appendix: []})
    },
    removeVisited(index) {
      if (this.info.customer_visited[index].customer) {
        if (confirm('您已有更新内容，确认是否要删除？')) {
          if (confirm('您已有更新内容，再次确认是否要删除？')) {
            this.info.customer_visited.splice(index, 1)
          }
        }
      } else {
        this.info.customer_visited.splice(index, 1)
      }
    },
    removeSolution(index) {
      this.info.solutions.splice(index)
    },
    checkMobile(event) {
      const reg = /^1[0-9]{10}$/
      if (!reg.test(event.target.value)) {
        this.$vux.alert.show({
          title: '',
          content: '请输入正确的手机号'
        })
      }
    },
    choseCustomer(index, value, type) {
      switch (type) {
        case 'visited':
          this.info.customer_visited[index].customer = value
          this.saveInfo()
          this.isVisitedCustomer = false
          break
        case 'solution':
          this.info.solutions[index].customer = value
          this.isSolutionCustomer = false
          break
      }
    },
    searchCustomer(even, type) {
      const header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
      this.$http.get('/api/v1/srvp_projects/project_similar?&offset=0&count=20&tp=customer&arg=' + event.target.value, header).then(response => {
        if (type === 'visited') {
          this.isVisitedCustomer = true
        } else if (type === 'solution') {
          this.isSolutionCustomer = true
        }
        this.customerList = response.data.content
      })
    },
    changeTextarea(value) {
      this.saveInfo()
      const num = typeof value === "string" ? value.split('\n').length : value.target.value.split('\n').length
      if (num === 3) {
        this.textnum = 3
      } else if (num >= 4) {
        this.textnum = 4
      }
    },
    changeDate() {
      const start = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
      const end = new Date()
      const startDate = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate()
      const endDate = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate()
      this.$vux.datetime.show({
        value: this.dateTime, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        startDate,
        endDate,
        onConfirm: (event) => {
          this.getInfoFromDate(event)
        }
      })
    },
    choseImg(visitedindex) {
      if (this.info.customer_visited[visitedindex].photos.length >= 5) {
        alert('最多允许上传5张照片')
        return
      }
      wx.chooseImage({
        count: 5 - this.info.customer_visited[visitedindex].photos.length, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: (res) => {
          this.$vux.loading.show({
            text: 'Loading'
          })
          const localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          let i = 0;
          const length = localIds.length
          const serverIds = []
          const upload = () => {
            wx.uploadImage({
              localId: localIds[i],  // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: async (res) => {
                // 返回图片的服务器端ID
                const header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                }
                serverIds.push(res.serverId);
                i++
                if (i >= length) {
                  const response = await this.$http.post('/api/v1/photos/wechat', {photo: serverIds}, header)
                  if (response.data) {
                    this.info.customer_visited[visitedindex].photos = [...this.info.customer_visited[visitedindex].photos, ...response.data]
                    for (const item of response['data']) {
                      const photo = await this.$http.get('api/v1/photos?path=' + item.thumb)
                      this.imgList[visitedindex].push('data:image/jpeg;base64,' + photo.data['value'])
                      this.$vux.loading.hide()
                    }
                  }
                }
                if (i < length && i <= 9) {
                  upload()
                }
              }
            })
          }
          upload()
        },
        fail: () => {
          this.$vux.loading.hide()
        }
      })
    },
    removeImg(visitedindex, photoindex) {
      this.imgList[visitedindex].splice(photoindex, 1)
      this.info.customer_visited[visitedindex].photos.splice(photoindex, 1)
    },
    removeAppendix(index) {
      this.info.appendix.splice(index, 1)
    },
    removeSolutionAppendix(solutionindex, index) {
      this.info.solutions[solutionindex].appendix.splice(index, 1)
    },
    async choseAppendix(type, index) {
      let fs;
      let appendix = []
      switch (type) {
        case 'appendix':
          fs = this.$refs.file.files
          if (this.info.appendix) {
            appendix = [...this.info.appendix]
          }
          if (appendix.length >= 3) {
            alert('最多允许上传3份附件')
            return
          }
          break;
        case 'solution':
          fs = this.$refs.filesolution[index].files
          break;
      }
      this.$vux.loading.show({
        text: 'Loading'
      })
      for (let i = 0; i < fs.length; i++) {
        const formData = new FormData()
        let d = fs[i]
        if (d.size <= 1024 * 1024 * 100) {  //文件必须小于100M
          formData.append("file", fs[i]);
          const arr = d.name;
          formData.append("name", arr);
          const response = await this.$http.post('api/v1/photos/upload', formData)
          appendix.push({path: response.data.path, suffix: arr})
        } else {
          alert('上传文件过大！')
          return false
        }
      }
      this.$vux.loading.hide()
      switch (type) {
        case 'appendix':
          this.info.appendix = appendix
          break;
        case 'solution':
          this.info.solutions[index].appendix = appendix
          break;
      }
    },
    async submit() {
      for (let i = 0; i < this.info.customer_visited.length; i++) {
        const item = this.info.customer_visited[i];
        if (!item.customer && !item.name) {
          this.info.customer_visited.splice(i, 1);
          i--;
          continue
        }
        if (!item.communicate) {
          alert('请选择客户拜访的沟通方式')
          return;
        }
        if (!item.mobile) {
          alert('请填写客户拜访的联系手机')
          return;
        }
        if (!item.prop) {
          alert('请填写客户性质')
          return
        }
        const reg = /^1[0-9]{10}$/
        if (!reg.test(item.mobile)) {
          alert('请输入正确的手机号')
          return
        }
      }
      for (let i = 0; i < this.info.solutions.length; i++) {
        const item = this.info.solutions[i];
        if (!item.appendix || !item.customer) {
          alert('请补充提交方案情况');
          return;
        }
      }
      if (!this.info.myscore) {
        this.$vux.alert.show({
          title: '',
          content: '请填写自我评分'
        })
        return;
      }
      if (this.isEditChange) {
        this.editInfo()
      } else {
        this.createInfo()
      }
    },
    createInfo() {
      const header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
      this.info.resources = this.resource ? this.resource.split('\n') : [];
      this.info.others = this.other ? this.other.split('\n') : [];
      this.info.next = this.next ? this.next.split('\n') : [];
      const info = {
        day: this.dateTime,
        info: this.info
      };
      this.$http.post('/api/v1/sale_logs', info, header).then(async (res) => {
        await this.$http.get('/api/v1/sale_logs/' + res.data.logid + '/set_salelog_visible_to?userids=' + JSON.stringify(this.visiable) + '&visible=true', header)
        this.$vux.alert.show({
          title: '',
          content: '创建成功'
        })
        localStorage.removeItem(this.dateTime)
        this.$emit('editAcreate')
      }).catch(error => {
        this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        })
      })
    },
    async editInfo() {
      const header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
      for (let i = 0; i < this.info.customer_visited.length; i++) {
        const item = this.info.customer_visited[i];
        if (!item.customer && !item.name) {
          this.info.customer_visited.splice(i, 1);
          i--;
        }
      }
      this.info.resources = this.resource ? this.resource.split('\n') : [];
      this.info.others = this.other ? this.other.split('\n') : [];
      this.info.next = this.next ? this.next.split('\n') : [];
      if (this.isClear) {
        this.$http.delete('/api/v1/sale_logs/' + this.isClear, header).then(() => {
        }).catch(error => {
          this.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          })
        })
      }
      if (this.info.id) {
        const info = {
          customer_visited: this.info.customer_visited,
          resources: this.info.resources,
          others: this.info.others,
          next: this.info.next,
          appendix: this.info.appendix ? this.info.appendix : [],
          photos: this.info.photos ? this.info.photos : [],
          solutions: this.info.solutions ? this.info.solutions : [],
          myscore: this.info.myscore
        }
        try {
          await this.$http.get('/api/v1/sale_logs/' + this.info.id + '/set_salelog_visible_to?userids=' + JSON.stringify(this.visiable) + '&visible=true', header)
          await this.$http.put('/api/v1/sale_logs/' + this.info.id, {info}, header)
          this.$vux.alert.show({
            title: '',
            content: '修改成功'
          })
          this.$emit('editAcreate')
          this.$router.push({name: 'saleslog'})
        } catch (error) {
          this.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          })
        }
      } else {
        const info = {
          day: this.dateTime,
          info: this.info
        };
        this.$http.post('/api/v1/sale_logs', info, header).then(async (res) => {
          await this.$http.get('/api/v1/sale_logs/' + res.data.logid + '/set_salelog_visible_to?userids=' + JSON.stringify(this.visiable) + '&visible=true', header)
          this.$vux.alert.show({
            title: '',
            content: '修改成功'
          })
          this.$emit('editAcreate')
        }).catch(error => {
          this.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          })
        })
      }
    },
    getInfoFromDate(date) {
      const header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
      this.$http.get('/api/v1/sale_logs/get_my_salelog_by_day?day=' + date, header).then(response => {
        if (this.isEditChange) {
          if (response.data) {
            if (date === this.date) {
              this.info = response.data
              this.imgList = []
              this.visiable = []
              /*this.info.photos.forEach(async item => {
                const photo = await this.$http.get('api/v1/photos?path=' + item.origin)
                this.imgList.push('data:image/jpeg;base64,' + photo.data['value'])
              })*/
              this.info.customer_visited.forEach(item => {
                this.imgList.push([])
              })
              this.info.next.forEach((item, index) => {
                this.next += index === 0 ? item : '\n' + item;
              });
              this.info.resources.forEach((item, index) => {
                this.resource += index === 0 ? item : '\n' + item;
              });
              this.info.others.forEach((item, index) => {
                this.other += index === 0 ? item : '\n' + item;
              });
              return
            }
            this.$vux.alert.show({
              title: '',
              content: '您' + response.data['time'] + '已有日志，请修改为其他日期或编辑当天日志进行修改'
            })
            this.dateTime = this.info.time;
          } else {
            if (confirm('确认将' + this.info.time + '日志修改' + date + '日志，修改后' + this.info.time + '日志需要重新填写，确认修改？')) {
              this.info.project_added = response.data ? response.data['project_added'] : [];
              this.info.project_updated = response.data ? response.data['project_updated'] : [];
              this.info.appendix = response.data ? response.data['appendix'] : [];
              this.info.photos = response.data ? response.data['photos'] : [];
              this.info.solutions = response.data ? response.data['solutions'] : []
              this.dateTime = date;
              this.isClear = this.info.id;
              delete this.info.id;
            } else {
              this.dateTime = this.info.time;
            }
          }
        } else {
          const info = localStorage.getItem(this.dateTime)
          this.imgList = []
          if (response.data) {
            if (response.data.write) {
              this.$vux.alert.show({
                title: '',
                content: '您' + date + '已提交过日志，请修改为其他日期或编辑当天的日志进行修改'
              })
              this.info.project_updated = response.data['project_updated'];
              this.info.project_added = response.data['project_added'];
            } else {
              if (this.resource || this.other || this.next) {
                if (!confirm('您已有写入内容，确认将当前写入内容修改为' + date + '日志')) {
                  const info_json = JSON.parse(info)
                  if (info_json && info_json.hasOwnProperty('date') && (info_json.date === date)) {
                    this.info = info_json
                    delete this.info.date
                  } else {
                    this.info = {
                      project_added: [],
                      project_updated: [],
                      customer_visited: [],
                      solutions: [],
                      next: [],
                      others: [],
                      resources: [],
                      photos: [],
                      appendix: []
                    }
                  }
                }
              }
              this.info.project_updated = response.data.project_updated
              this.info.project_added = response.data.project_added
              this.info.id = response.data.id
              this.isEditChange = true
            }
          } else {
            if (this.resource || this.other || this.next) {
              if (!confirm('您已有写入内容，确认将当前写入内容修改为' + date + '日志')) {
                if (info) {
                  const info_json = JSON.parse(info)
                  if (info_json.date === date) {
                    this.info = info_json
                    delete this.info.date
                  } else {
                    this.info = {
                      project_added: [],
                      project_updated: [],
                      customer_visited: [],
                      next: [],
                      others: [],
                      resources: [],
                      appendix: [],
                      photos: [],
                      solutions: []
                    }
                  }
                } else {
                  this.info = {
                    project_added: [],
                    project_updated: [],
                    customer_visited: [],
                    next: [],
                    others: [],
                    resources: [],
                    appendix: [],
                    photos: [],
                    solutions: []
                  }
                }
              }
            } else {
              this.info = {
                project_added: [],
                project_updated: [],
                customer_visited: [],
                next: [],
                others: [],
                resources: [],
                appendix: [],
                photos: [],
                solutions: []
              };
            }
          }
          this.dateTime = date
          this.visiable = []
          this.imgList = []
          this.info.customer_visited.forEach(item => {
            this.imgList.push([])
          })
          this.info.next.forEach((item, index) => {
            this.next += index === 0 ? item : '\n' + item;
          });
          this.info.resources.forEach((item, index) => {
            this.resource += index === 0 ? item : '\n' + item;
          });
          this.info.others.forEach((item, index) => {
            this.other += index === 0 ? item : '\n' + item;
          });
        }
      }).catch(error => {
        console.log(error)
        this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        })
      })
    },
    getVisiable() {
      const header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
      this.$http.get('/api/v1/sale_logs/' + this.id + '/list_salelog_visible_to?offset=0&count=9999', header).then(res => {
        this.visiableUserList = res.data['content'].filter(item => {
          return item.default;
        })
        res.data['content'].forEach(item => {
          if (!item.default) {
            this.visiable = [...this.visiable, item.userid];
          }
        })
      }).catch(error => {
        this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        })
      });
    },
    getVisiableUser() {
      const header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
      this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=', header).then(response => {
        this.visiableUser = response.data;
      }).catch(error => {
        this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        })
      })
    },
    saveInfo() {
      this.info.date = this.dateTime
      this.info.resources = this.resource ? this.resource.split('\n') : [];
      this.info.others = this.other ? this.other.split('\n') : [];
      this.info.next = this.next ? this.next.split('\n') : [];
      localStorage.setItem(this.dateTime, JSON.stringify(this.info));
    }
  },
  mounted() {
    setTimeout(() => {
      const timestamp = parseInt(new Date().getTime() / 1000)
      var url
      var u = navigator.userAgent
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      this.$http.get('static/config.json').then(response => {
        const config = response.data
        url = isiOS ? config.host + global_.entryUrl.split('?')[0] : config.host + this.$route.path;
        const noncestr = Math.random().toString(36).substr(2)
        this.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then((response) => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode'] // 必填，需要使用的JS接口列表
          })
          wx.error((res) => {
            //alert(res.errMsg)
          })
        })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data)
            } else if (error.request) {
              console.log(error.request)
            } else {
              console.log('Error', error.message)
            }
          })
      }, response => {
        console.log('数据加载失败')
      })
    }, 500)
  },
  created() {
    this.getInfoFromDate(this.date)
    this.getVisiableUser()
    if (this.id) {
      this.getVisiable()
    } else {
      const header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
      this.$http.get('/api/v1/sale_logs/get_salelog_config?userid=' + localStorage.getItem('userid') + '&offset=0&count=999999', header).then(res => {
        this.visiableUserList = res.data['content'].map(item => {
          return {name: item.srvp.name};
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Saleslog/addsaleslog.vue